/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-height[_ngcontent-%COMP%]{height:100%}\n/*# sourceMappingURL=ger-info.component.css.map*/"];
export { styles as styles };
